import React from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'

const IntegrationsPanel = React.lazy(
  //@ts-expect-error
  () => import('orgSettings/integrations-panel')
)
const AdrIntegrationsPanel = React.lazy(
  //@ts-expect-error
  () => import('orgSettings/adr-integrations-panel')
)

export const IntegrationsPanelComponent = () => {
  const isEmbeddedInNS = window.isEmbeddedInNS === true

  return (
    <RemoteComponent>
      <AdrIntegrationsPanel isNorthStar={isEmbeddedInNS} />
      <IntegrationsPanel />
    </RemoteComponent>
  )
}
